module.exports = __webpack_public_path__ + "static/media/trial2_3.2e26f31a.png";